import { gql } from '@apollo/client';
import CHANNEL from '../fragments/CHANNEL';
const GET_CHANNELS = gql `
  query GetChannels {
    getChannels {
      ...ChannelFragment
    }
  }
  ${CHANNEL}
`;
export default GET_CHANNELS;
